var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", [
        _c("div", { staticClass: "v-modal" }),
        _c(
          "div",
          { staticClass: "text-center discount-coupon" },
          [
            _c("div", {
              staticClass: "pointer close",
              on: { click: _vm.close }
            }),
            _c(
              "el-carousel",
              { staticClass: "carousel", attrs: { height: "620px" } },
              _vm._l(_vm.data, function(item, index) {
                return _c("el-carousel-item", { key: index }, [
                  _c("div", { staticClass: "price" }, [
                    _vm._v("\n          ¥"),
                    _c("span", { staticClass: "arial fb f80" }, [
                      _vm._v(_vm._s(item.price))
                    ])
                  ]),
                  _c("div", { staticClass: "condition" }, [
                    _vm._v(_vm._s(item.des))
                  ])
                ])
              }),
              1
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }